import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import TopHeader from './side/TopHeader';
import Sidebar from './side/Sidebar';
import Pagination from './side/Pagination';
import ConfirmPopup from './side/ConfirmPopup';
import '../css/NoticeManagement.css';
import { SERVER_URL } from '../../config/config';

const NoticeManagement = () => {
  const navigate = useNavigate();
  const [notices, setNotices] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const [showConfirmPopup, setShowConfirmPopup] = useState(false);
  const [noticeToDelete, setNoticeToDelete] = useState(null);
  const [selectedNotice, setSelectedNotice] = useState(null);
  const itemsPerPage = 5; // 페이지당 항목 수

  useEffect(() => {
    fetchNotices();
  }, [currentPage]);

  const fetchNotices = async () => {
    try {
      const response = await axios.get(`${SERVER_URL}/admin/notice`);
      
      if (response.data.result_code === 201) {
        setNotices(response.data.notices);
        setTotalCount(response.data.notices.length);
      } else {
        console.error('Error fetching notices:', response.data.message);
      }
    } catch (error) {
      console.error('Error fetching notices:', error);
    }
  };

  // 현재 페이지의 항목들만 가져오기
  const getCurrentItems = () => {
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = startIndex + itemsPerPage;
    return notices.slice(startIndex, endIndex);
  };

  // 총 페이지 수 계산
  const totalPages = Math.ceil(totalCount / itemsPerPage);

  const handleWriteClick = () => {
    navigate('/admin/notice/write');
  };

  const handleDeleteClick = async (noticeId, e) => {
    e.stopPropagation();
    setNoticeToDelete(noticeId);
    setShowConfirmPopup(true);
  };

  const handleConfirmDelete = async () => {
    try {
      await axios.delete(`${SERVER_URL}/admin/notice/${noticeToDelete}?admin_id=${localStorage.getItem('adminId')}`);
      fetchNotices();
    } catch (error) {
      console.error('Error deleting notice:', error);
    }
    setShowConfirmPopup(false);
    setNoticeToDelete(null);
  };

  const handleCancelDelete = () => {
    setShowConfirmPopup(false);
    setNoticeToDelete(null);
  };

  const handleNoticeClick = async (noticeId) => {
    try {
      const response = await axios.get(`${SERVER_URL}/admin/notice/${noticeId}`);
      if (response.data.result_code === 201) {
        setSelectedNotice(response.data.notice);
      }
    } catch (error) {
      console.error('Error fetching notice detail:', error);
    }
  };

  const handleEditClick = () => {
    if (selectedNotice) {
      navigate(`/admin/notice/${selectedNotice.notice_id}/edit`);
    }
  };

  const handleBackToList = () => {
    setSelectedNotice(null);
  };

  return (
    <div className="user-management">
      <div className="content-wrapper">
        <Sidebar />
          {!selectedNotice ? (
            <div className="main-content">
              <div className="header-section">
                <h1>공지사항 관리({totalCount}개)</h1>
                <button className="button" onClick={handleWriteClick}>
                  글쓰기
                </button>
              </div>

              <div className="table-container">
                <div className="header-row">
                  <span>제목</span>
                  <span>작성자</span>
                  <span>작성시간</span>
                  <span>관리</span>
                </div>
                <div className="data-entries">
                  {getCurrentItems().map((notice) => (
                    <div
                      key={notice.notice_id}
                      className="table-row"
                      onClick={() => handleNoticeClick(notice.notice_id)}
                    >
                      <span className="cell" style={{ justifyContent: 'left' }}>{notice.title}</span>
                      <span className="cell">{notice.author_admin_id}</span>
                      <span className="cell">
                        {new Date(notice.created_at).toLocaleDateString()}
                      </span>
                      <span className="cell">
                        <button 
                          className="delete-button"
                          onClick={(e) => handleDeleteClick(notice.notice_id, e)}
                        >
                          삭제
                        </button>
                      </span>
                    </div>
                  ))}
                </div>
              </div>

              {totalPages > 0 && (
                <Pagination
                  currentPage={currentPage}
                  totalPages={totalPages}
                  onPageChange={setCurrentPage}
                />
              )}
            </div>
          ) : (
            <div className="main-content" id="notice-content">
              <div className="detail-header">
                <button className="back-button" onClick={handleBackToList}>
                  ← 목록으로
                </button>
                <h1>공지사항 상세</h1>
                <button className="button" id="edit-button" onClick={handleEditClick}>
                  수정하기
                </button>
              </div>
              
              <div className="detail-content">
                <div className="detail-row">
                  <div className="detail-label">제목</div>
                  <div className="detail-value">{selectedNotice.title}</div>
                </div>
                
                <div className="detail-row">
                  <div className="detail-label">작성자</div>
                  <div className="detail-value">{selectedNotice.author_admin_id}</div>
                </div>
                
                <div className="detail-row">
                  <div className="detail-label">작성일</div>
                  <div className="detail-value">{new Date(selectedNotice.created_at).toLocaleDateString()}</div>
                </div>
                
                <div className="detail-row">
                  <div className="detail-label">내용</div>
                  <div className="detail-value content-text">{selectedNotice.content}</div>
                </div>
              </div>
            </div>
          )}
      </div>
      {showConfirmPopup && (
        <ConfirmPopup
          message="공지사항을 삭제하시겠습니까?"
          onConfirm={handleConfirmDelete}
          onCancel={handleCancelDelete}
        />
      )}
    </div>
  );
};

export default NoticeManagement; 